import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { GlowOrb } from "@/components/common/GlowOrb";
import { COMPANY } from "@/data/site";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      localStorage.setItem("cl_token", r.data.access_token);
      localStorage.setItem("cl_email", r.data.email);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error("Invalid credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center px-6 overflow-hidden" data-testid="admin-login-page">
      <GlowOrb className="top-0 left-0" color="primary" size={600} />
      <GlowOrb className="bottom-0 right-0" color="secondary" size={600} />
      <div className="relative w-full max-w-md">
        <div className="flex items-center justify-center gap-2 mb-8">
          <img src={COMPANY.logo} alt="CloudLab" className="h-9 w-auto" />
          <span className="font-heading font-bold text-xl">CloudLab Admin</span>
        </div>
        <form onSubmit={submit} className="glass rounded-3xl p-8 space-y-5" data-testid="admin-login-form">
          <h1 className="font-heading font-bold text-2xl">Sign in</h1>
          <div>
            <label className="text-xs font-mono uppercase tracking-[0.2em] text-muted-foreground">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-2 w-full bg-transparent border border-border rounded-xl px-4 py-3 focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/30"
              data-testid="admin-login-email" />
          </div>
          <div>
            <label className="text-xs font-mono uppercase tracking-[0.2em] text-muted-foreground">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="mt-2 w-full bg-transparent border border-border rounded-xl px-4 py-3 focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/30"
              data-testid="admin-login-password" />
          </div>
          <button disabled={loading} type="submit"
            className="w-full rounded-full px-6 py-3 bg-primary text-primary-foreground text-sm font-semibold btn-neon disabled:opacity-50"
            data-testid="admin-login-submit">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
